import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = api.token();
    if (!t) { setLoading(false); return; }
    api.me()
      .then((data) => {
        // Ensure preferences exists with a default stub if backend hasn't shipped it yet
        const u = data.user;
        if (u && !u.preferences) u.preferences = {};
        setUser(u);
      })
      .catch(() => api.setToken(null))
      .finally(() => setLoading(false));
  }, []);

  // Persist a session (token + user) and hydrate in-memory state.
  // Shared by login and by the email-verification flow so the token is stored
  // identically in every path.
  const applySession = (token, user) => {
    api.setToken(token);
    if (user && !user.preferences) user.preferences = {};
    setUser(user);
    return user;
  };

  const login = async (email, password) => {
    const { token, user } = await api.login(email, password);
    return applySession(token, user);
  };
  const signup = async (body) => {
    const res = await api.signup(body);
    // When email verification is enabled the backend returns
    // { pendingVerification: true, email } and NO token — the caller routes
    // the user to the verify page instead of logging them in.
    if (res && res.pendingVerification) return res;
    return applySession(res.token, res.user);
  };
  const logout = () => { api.setToken(null); setUser(null); };

  // Update the in-memory user object (e.g. after preferences are saved)
  const updateUser = (patch) => setUser((u) => u ? { ...u, ...patch } : u);

  return <AuthCtx.Provider value={{ user, loading, login, signup, applySession, logout, updateUser }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
